export default __webpack_public_path__ + "static/media/Badge-GooglePlay@2x.990e4263.png";